import React from "react";

export function ProjectCard({ project, onClick }) {
    return (
      <button
        onClick={onClick}
        className="group relative block w-full overflow-hidden rounded-xl bg-gray-900 transition-all duration-300 hover:scale-[1.02] hover:shadow-[0_0_30px_rgba(0,149,255,0.3)]"
      >
        <div className="aspect-[4/3] relative">
          <img
            src={project.image}
            alt={project.title}
            className="object-cover transition-transform duration-300 group-hover:scale-110"
            style={{ width: "100%", height: "100%", position: "absolute", objectFit: "cover" }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
          {/* Display "New" Tag */}
          {project.isNew && (
            <span className="absolute top-2 right-2 -rotate-12 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded shadow-lg">
              NEW
            </span>
          )}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <div className="space-y-1">
            <h3 className="text-xl font-semibold text-white">
              {"isComingSoon" in project ? (
                <span className="text-2xl font-bold tracking-wider text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">
                  COMING SOON
                </span>
              ) : (
                project.title
              )}
            </h3>
            {!("isComingSoon" in project) && (
              <p className="text-sm text-blue-400">{project.category}</p>
            )}
          </div>
        </div>
      </button>
    );
  }
  